import api from '../technique/api';

export const AccountBDL = () => ({
  removeAccount: async (id: string, password: string, motif: string) =>
    await api.post('auth/utilisateur/delete', {
      id: id,
      password: password,
      motif: motif,
    }),
  checkAccount: async (email: string, password: string) =>
    await api.post('auth/authentification', {email: email, password: password}),
});
